<template>
    <div id="app">
        <router-view></router-view>
        <el-dialog title="消息" class="messageBox" :visible.sync="messageShow" width="80%">
            <el-table >
            <el-table-column property="Tit" label="标题" width="150"></el-table-column>
            <el-table-column property="content" label="内容" width="200"></el-table-column>
            <el-table-column property="time" label="时间"></el-table-column>
            <el-table-column  label="操作" width="200"></el-table-column>
          </el-table>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'App',
    data() {
        return {
            messageShow:false,
        };
    },
    mounted() {

    },
    methods: {


    },

}
</script>
<style>
@font-face {
    font-family: 'NotoSansCJK';
    font-weight: 300;
    src: url('/src/fonts/NotoSansCJK-Regular-1.otf') format('truetype');
}

@font-face {
    font-family: 'Montserrat';
    src: url('/src/fonts/Montserrat-Light-6.otf') format('truetype');
}

body,
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'NotoSansCJK';
    font-weight: 300;
    color: #333;
    font-size: 14px;
}

#app {
    width: 100%;
    height: 100vh;
    background: #f7f8f9;
    min-width: 1280px;
}

/* 测导航 */
.app_aside {
    width: 120px !important;
    height: 100%;
    background: #333;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.app_logo {
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.app_logo img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}


.app_asideNav {
    margin-top: 30px;
}

.app_asideItem {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 70px;
    height: 70px;
    border-radius: 16px;
    justify-content: center;
    margin-bottom: 20px;
    cursor: pointer;
    transition: all 0.48s;
}

.app_asidIcon {
    width: 25px;
    height: 25px;
    position: relative;
}

.app_asidIcon svg {
    width: 100%;
    height: 100%;
}

.app_asidIcon svg path {
    fill: #fff;
}

.app_asideItem p {
    font-size: 14px;
    color: #fff;
    margin-top: 8px;
    transition: all 0.48s;
}

.app_asideItem.app_asideAct {
    background: #fff;
}

.app_asideItem.app_asideAct .app_asidIcon svg path {
    fill: #FF5000;
}

.app_asideItem.app_asideAct p {
    color: #FF5000;
}

.app_asideItem:hover {
    background: #fff;
}

.app_asideItem:hover .app_asidIcon svg path {
    fill: #FF5000;
}

.app_asideItem:hover p {
    color: #FF5000;
}











.el-header {
    background: #fff;
    border-bottom: 1px solid rgba(0, 0, 0, .1);
    z-index: 999;
}

.el-container {
    width: 100%;
    height: 100%;
}

.app_mlTable {
    width: 100%;
    margin-top: 30px;
}

.el-dropdown{
  cursor: pointer;
}
/* 表格 */
.el-table th.el-table__cell {
    background: rgb(255, 80, 0, .6) !important;
}

.el-table th.el-table__cell>.cell {
    color: #fff;
    font-weight: 500;
    font-size: 16px;
}

.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
    border-bottom: none;
}

.el-table td.el-table__cell div {
    font-size: 14px;
}

.el-table tr:nth-child(2n) {
    background: #f7f8f9;
}

.el-table--fit {
    border-left: 1px solid rgba(0, 0, 0, .1);
    border-right: 1px solid rgba(0, 0, 0, .1) !important;
    border-radius: 16px;
    overflow: hidden;
}

.el-table .el-table__cell {
    padding: 10px 0 !important;
}

.el-table th.el-table__cell {
    padding: 15px 0
}

.el-table .cell {
    padding: 0 20px;
    text-align: center;
}

.el-table th.el-table__cell>.cell {
    padding: 0 20px
}

.el-table__body tr.hover-row.current-row>td.el-table__cell,
.el-table__body tr.hover-row.el-table__row--striped.current-row>td.el-table__cell,
.el-table__body tr.hover-row.el-table__row--striped.selection-row>td.el-table__cell,
.el-table__body tr.hover-row.el-table__row--striped>td.el-table__cell,
.el-table__body tr.hover-row.selection-row>td.el-table__cell,
.el-table__body tr.hover-row>td.el-table__cell {
    background-color: rgb(255, 80, 0, .1);
}

.app_mlTableCk.el-button {
    background: transparent !important;
}
.app_mlTableCk span {
    font-size: 14px;
    color: #FF5000 !important;
}
.el-message-box__btns .el-button:nth-child(1){
  background: #f7f8f9 !important;
}
.el-message-box__btns .el-button:nth-child(1) span{
    color: #333;
}
.app_headInp .el-input__inner {
  background: #f7f8f9;
  border-radius: 8px;
}
.el-form-item__content .taskItema{
  width: 45%;
}
.taskItem{
  width: 24%;
}















/* 首页右侧 */
.app_Rig {
    width: 100%;
    height: 100%;
}

.app_RigW {
    width: 100%;
}

.el-main {
    height: calc(100% - 50px);
    width: 100%;
    position: relative;
}




















/* 页脚 */
.app_page{
    margin-top: 30px;
    display: flex;
    justify-content: end;
    align-items: center;
}
.el-select-dropdown__item span{
    font-size: 12px;
}
.app_page .el-pager li.active{
    color: #FF5000;
}
.app_page .el-pager li:hover {
    color: #FF5000;
}
.el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner{
    border-color: #FF5000 !important;
}
.el-pagination__sizes .el-input .el-input__inner:hover{
    border-color: #FF5000 !important;
}
.el-select .el-input__inner:focus{
    border-color: #FF5000 !important;
}



.el-button{
    background: #FF5000 !important;
    border:  none !important;
    border-radius: 8px !important;
}
.el-button span{
    font-size: 14px;
    color: #fff;
}
.app_mlTable .el-button:focus, .app_mlTable .el-button:hover{
    background: transparent !important;
}
.el-button:focus, .el-button:hover{
    background: #FF5000 !important;
}

/*  */

.app_TNav {
    width: 100%;
    height: 40px;
    background: #fff;
    /* padding: 0 20px; */
}

.app_TList {
    display: flex;
    align-items: center;
    height: 100%;
    background: #fefefe;
    /* border-bottom: 1px solid rgba(0, 0, 0, .1); */
}

.app_TItem {
    cursor: pointer;
    /* background: #f1f2f3; */
    font-size: 14px;
    height: 100%;
    padding: 0 30px;
    /* border-radius: 8px; */
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.app_TItem i {
    font-size: 14px;
    margin-left: 8px;
}

.app_TAct {
    background: rgb(255, 80, 0, .2);
    color: rgb(255, 80, 0);
}

.app_TAct i {
    color: #FF5000;
}

.app_TItem::after {
    width: 0%;
    height: 2px;
    position: absolute;
    left: 0;
    bottom: 0;
    content: '';
    background-color: #FF5000;
    transition: all 0.48s;
}

.app_TAct::after {
    width: 100%;
}










/* 暂无数据 */
.el-table__empty-block{
    min-height: 1px !important;
    height: 1px !important;
}
.el-table__empty-text{
    opacity: 0;
}

</style>